module.exports = __webpack_public_path__ + "static/generalAssembly-56a61fe10a6ca7ebe76563c5492b38c2.jpg";